import '@main';
import '@vendor/@fancyapps/ui/dist/index.umd.js';
import type { userSlideType } from '@fancyapps/ui/types/Carousel/types';

await u.domready();
u.importCSS('@vendor/@fancyapps/ui/dist/fancybox/fancybox.css');

const interiorThumbSwiper = new Swiper(
  '.j-interior-thumb-swiper',
  {
    slidesPerView: 1.5,
    spaceBetween: 12,
    centeredSlides: true,
    loop: true,
    rewind: true,
    navigation: {
      nextEl: ".j-interior-thumb-swiper-next",
      prevEl: ".j-interior-thumb-swiper-prev",
    },
    breakpoints: {
      spaceBetween: 20,
    }
  },
);

const showFancyBoxEl = document.querySelectorAll('[data-show-fancybox]');

showFancyBoxEl.forEach((el) => {
  el.addEventListener('click', () => {
    const group = el.getAttribute('data-fancybox-group');
    const startIndex = parseInt(el.getAttribute('data-start-index') || "0", 10);

    const imageElements = document.querySelectorAll<HTMLImageElement>(
      `[data-fancybox-image][data-fancybox-group="${group}"]:not(.swiper-slide-duplicate [data-fancybox-image])`
    );

    const images: userSlideType[] = [];
    imageElements.forEach((image) => {
      images.push({
        src: image.src,
        type: 'image',
      });
    });

    Fancybox.show(images, {
      startIndex: startIndex,
      mainClass: 'c-fancybox',
      Thumbs: {
        type: "classic",
      },
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close'],
        },
      }
    });
  });
});
